<template>
  <div class="brands" :style="{transform: 'translate(0px, '+startY+'px) translateZ(0px)'}">
    <div
      class="item"
      @click="getBrandId(0)"
      style="line-height:0.9rem;height:0.9rem;"
      :class="0==brandId?'active':''"
    >
      <span>全部</span>
    </div>
    <div
      class="item"
      v-for="item in brands"
      :key="item.id"
      @click="getBrandId(item)"
      :class="item.id==brandId?'active':''"
    >
      <div class="image" :style="'background:url('+item.logo+') no-repeat;background-size: 100%;'"></div>
      <span>{{item.name}}</span>
    </div>
  </div>
</template>
<style scoped>
.brands {
  position: fixed;
  top: 0.9rem;
  width: 0.8rem;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}
.brands .item {
  text-align: center;
  border-bottom: solid #efefef 1px;
  padding: 0.1rem 0;
  height: 0.9rem;
  background: #fff;
  border-left: 3px solid #fff;
}
.brands .item.active {
  background: #f8f8f8;
  border-left: 3px solid #3782ff;
  color: #3782ff;
}
.brands .item .image {
  width: 0.5rem;
  height: 0.4rem;
  display: inline-block;
}
.brands .item span {
  display: block;
}
</style>
<script>
export default {
  props: ["brands","brandId"],
  data() {
    return {
      active: 0,
      startY: 0
    };
  },
  components: {},
  mounted: function() {
  },
  methods: {
    getBrandId(item) {
      if (this.BrandId !== item.id) {
        window._hmt.push(['_trackEvent', '回收分类品牌', '点击', item.name,item.id]); 
        this.$emit("getBrandId", item.id);
      }
    }
  }
};
</script>